import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { object, string } from 'yup';
import {
  Formik,
  Form,
} from 'formik';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons/faDoorOpen';

import { useHttpStatus } from '~/commons/hooks';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';

const schema = object().shape({
  email: string()
    .trim()
    .lowercase()
    .email('必須為有效電郵地址')
    .required('必填'),
  password: string()
    .required('必填'),
});
const defaults = {
  email: '',
  password: '',
};

const FormLogin = ({
  title = '',
  router = true,
}) => {
  const [persist, setPersist] = useState(true);
  const [res, req] = useHttpStatus({
    onSuccess() {
      window.location.replace('/admin');
    },
  });

  return (
    <>
      <div className="row mb-3">
        <div className="col">{title}</div>
      </div>
      <Formik
        validationSchema={schema}
        initialValues={defaults}
        onSubmit={(values) => req({
          method: 'post',
          url: '/api/core/auth',
          data: {
            ...values,
            web: 1,
            persist,
          },
        })}
      >
        <Form>
          <FormHttpAlert res={res} />
          <FormGroup
            name="email"
            label={null}
            placeholder="帳戶"
          />
          <FormGroup
            name="password"
            type="password"
            label={null}
            placeholder="密碼"
          />
          <div className="row mb-3">
            <div className="col">
              <div className="form-check form-control-sm">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="persist"
                  checked={persist}
                  onChange={() => setPersist(!persist)}
                />
                <label
                  className="form-check-label"
                  htmlFor="persist"
                >
                  保持登入
                </label>
              </div>
            </div>
            <div className="col-auto">
              {router ? (
                <Link to="/auth/pwd-recovery">
                  <small>忘記密碼?</small>
                </Link>
              ) : (
                <a href="/auth/pwd-recovery">
                  <small>忘記密碼?</small>
                </a>
              )}
            </div>
          </div>
          <div className="form-group text-right">
            <FormHttpBtn
              res={res}
              type="submit"
              className="btn-tertiary btn-block"
              icon={faDoorOpen}
            >
              登入
            </FormHttpBtn>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export default FormLogin;
